module.exports = __webpack_public_path__ + "img/for-women-5.5bc5182.webp";